






















































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";
import { roles } from "@/config/roles";

import { getElegantDateString, getElegantDateStringFromString } from "@/utils/date-helpers";
import { teamUrl } from "@/utils/url-helpers";

/**
 * Components
 */
import EditCompositionGroupDialog from "@/components/composition/components/EditCompositionGroupDialog.vue";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * API
 */
import compositionsAPI from "@/api/compositions";
import { GetOneCompositionGroupResponse } from "@/api/compositions/get-one-composition-group.response";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { Guid } from "@/domain/guid";


/**
 * Types
 */

/**
 * VueX Modules
 */
const teamModule = namespace("team");


/**
 * Event view page.
 */
@Component({
	components: {
		DataFetcher,
		EditCompositionGroupDialog
	}
})
export default class EventPage extends Vue {
	$refs!: {
		editCompositionGroupDialog: EditCompositionGroupDialog;
	};

	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;
	getElegantDateString = getElegantDateString;
	getElegantDateStringFromString = getElegantDateStringFromString;

	teamUrl = teamUrl;

	/// Attributes
	isInternalLoading = false;
	isDataFetcherLoading = false;
	compositionGroup: GetOneCompositionGroupResponse | null = null;

	get isLoading() {
		return this.isDataFetcherLoading || this.isInternalLoading;
	}

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	get displayZoneID(): number | null {
		if (this.compositionGroup?.raid) return this.compositionGroup.raid.zoneID;
		if (this.compositionGroup?.raidGroup) return this.compositionGroup.raidGroup.zoneID;
		return null;
	}

	get canManageCompositions() {
		return this.hasPermission(roles.MANAGE_COMPOSITIONS);
	}

	/// Methods
	async created() {
	}

	async fetchCurrentCompositionGroup() {
		await this.fetchCompositionGroup(this.$route.params.id);
	}

	async fetchCompositionGroup(id: Guid) {
		this.compositionGroup = await compositionsAPI.fetchCompositionGroup(id);
	}

	async handleEditButtonClick() {
		if (this.compositionGroup) {
			await this.$refs.editCompositionGroupDialog.open(this.compositionGroup);
		}
	}

	async handleDeleteButtonClick() {
		if (window.confirm(this.$t("composition.alert_delete").toString())) {
			try {
				if (this.compositionGroup != null) {
					await compositionsAPI.deleteCompositionGroup(this.compositionGroup.id);
					await this.$router.push(teamUrl(this.currentTeam, "/calendar"));
				}
			} catch (error) {
				this.handleAPIError(error);
			}
		}
	}

	async handleTogglePublishedButtonClick() {
		this.isInternalLoading = true;
		try {
			if (this.compositionGroup != null) {
				await compositionsAPI.togglePublished(this.compositionGroup.id);
				await this.fetchCurrentCompositionGroup();
			}
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isInternalLoading = false;
	}

	replaceIdInPath(newId: string) {
		return this.$route.fullPath.replace(/\/events\/([0-9a-f\-]+)\//g, `/events/${newId}/`);
	}

	getPreviousEventLink() {
		return this.compositionGroup != null && this.compositionGroup.previousID ? this.replaceIdInPath(this.compositionGroup.previousID) : null;
	}

	getNextEventLink() {
		return this.compositionGroup != null && this.compositionGroup.nextID ? this.replaceIdInPath(this.compositionGroup.nextID) : null;
	}

	get childComponentKey() {
		return this.compositionGroup?.raidID || this.compositionGroup?.raidGroupID;
	}

	async handleAfterEditCompositionGroup() {
		if (this.compositionGroup == null)
			return;

		this.isInternalLoading = true;
		await this.fetchCurrentCompositionGroup();
		this.isInternalLoading = false;
	}
}
